import { useNode } from "@craftjs/core";
import React, { useContext } from "react";

import {
  ColorInput,
  UnitInput,
  Tabs,
  PaddingInput,
  MarginInput,
  Spacer,
  AlignInput,
  ToggleInput,
  Panel,
  BorderInput,
  BorderRadiusInput,
  BoxShadowInput,
  TextInput,
  MultipleSelect,
  SelectInput,
  RadioButtonInput,
} from "../../input";

import { supportLibrary } from "../../block-supports";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const FormFailSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const { blockState, setBlockState } = useContext(GrigoraDashboardContext);

  const { method, action, name } = props;

  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing="1rem"></Spacer>
      </div>
    );
  }

  function StyleSettings() {
    return (
      <>
        <div className="g-settings__wrapper"></div>
      </>
    );
  }

  function AdvancedSettings() {
    return (
      <>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
    },
  ];

  return (
    <div>
      <Tabs
        id={`block-settings-tab-${id}`}
        type="block-setting"
        items={tabs.map((item, i) => {
          return {
            label: item.label,
            key: item.key,
            children: item.children,
          };
        })}
      />
    </div>
  );
};
